import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers'
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container'


export default function GatewayRedisAndLogisticsInfoComponent ({handleFormChange,selectedGateway}: any) {
  return (
    <>
<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
isDisabled
              label="Host"
              name="Host"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                   'Redis.Host',
                  selectedGateway?.Redis
                )
              }}
              type="text"
              value={selectedGateway?.Redis?.Host}
          />
   <InputContainer
isDisabled
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                   'Redis.Port',
                  selectedGateway?.Redis
                )
              }}
              type="text"
              value={selectedGateway?.Redis?.Port}
          />
           <InputContainer
isDisabled
              label="User Name"
              name="UserName"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                   'Redis.UserName',
                  selectedGateway?.Redis
                )
              }}
              type="text"
              value={selectedGateway?.Redis?.UserName}
          />
            <InputContainer
isDisabled
icon
              label="Pwd"
              name="Pwd"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                   'Redis.Pwd',
                  selectedGateway?.Redis
                )
              }}
              type="password"
              value={selectedGateway?.Redis?.Pwd}
          />
           <InputContainer
isDisabled
              label="Database Name"
              name="Database"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                   'Redis.Database',
                  selectedGateway?.Redis
                )
              }}
              type="text"
              value={selectedGateway?.Redis?.Database}
          />
        </div>
}
    expandedPanel="Redis Info"
    headerTitle="Redis Info"
/>

<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
    <InputContainer
isDisabled
              label="Gateway"
              name="Gateway"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Gateway',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Gateway}
          />
           <InputContainer
isDisabled
              label="Registry"
              name="Registry"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Registry',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Registry}
          />
           <InputContainer
isDisabled
              label="BAP Id"
              name="BapId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BapId',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BapId}
          />
           <InputContainer
isDisabled
              label="bap Url"
              name="BapUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BapUri',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BapUri}
          />
           <InputContainer
isDisabled
              label="bpp Id"
              name="BppId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BppId',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BppId}
          />
           <InputContainer
isDisabled
              label="bpp Url"
              name="BppUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BppUri',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BppUri}
          />
           <InputContainer
isDisabled
              label="Domain"
              name="Domain"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Domain',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Domain}
          />
             <InputContainer
isDisabled
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Port',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Port}
          />
           <InputContainer
isDisabled
              label="Core Version"
              name="CoreVersion"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.CoreVersion',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.CoreVersion}
          />
        </div>
}
    expandedPanel="Logistics Info"
    headerTitle="Logistics Info"
/>
        </>
  )
}